import { render, staticRenderFns } from "./PurchaseInAppButton.vue?vue&type=template&id=90fbf510&scoped=true&"
import script from "./PurchaseInAppButton.vue?vue&type=script&lang=js&"
export * from "./PurchaseInAppButton.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseInAppButton.vue?vue&type=style&index=0&id=90fbf510&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90fbf510",
  null
  
)

export default component.exports